import { useEffect, useState } from 'react';

/**
 * Typing "business" is 8 keystrokes. Without this the page runs 8 searches;
 * with it, one.
 *
 * Debouncing the VALUE rather than the callback is what makes this safe in
 * React: a debounced function held in a ref closes over whatever state it was
 * created with, which is how a stale search overwrites a newer one.
 */
export function useDebouncedValue(value, ms) {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const t = setTimeout(() => setSettled(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);

  return settled;
}
